// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2lKgN","unreadBadge":"styles_unreadBadge__MCmX-","modalContent":"styles_modalContent__3NZaE","modal":"styles_modal__1sHVX"};